import * as React from 'react';
import {EditorSelectionContext} from '.';

export const useEditorSelectionContext = () =>
	React.useContext(EditorSelectionContext);
